import { createStore } from 'vuex';
import { EventEmitter } from 'events';
import { AuthorizedUser } from '@/models/authorized-user';

export default createStore({
  state: {
    authorizedUser: new AuthorizedUser(),
    eventController: new EventEmitter(),
    myCommittees: null,
    areaOfInterestsList:null,
    emailPreferencesList:null,
    myMemberDetails: null,
    eoiForm: null,
    countryList: null,
    dxExchangeTypeList: null,
    snackbar: [],
  },
  mutations: {
    setUserAccount(state, authorizedUser: AuthorizedUser) {
      state.authorizedUser = authorizedUser;
    },
    setSnackbar(state, sb) {
      state.snackbar = sb;
    },
    setMyCommittees(state, mc) {
      state.myCommittees = mc;
      window.sessionStorage.setItem('myCommittees', JSON.stringify(mc));
    },
    setAreaOfInterests(state, aoi) {
      state.areaOfInterestsList = aoi;
      window.sessionStorage.setItem('areaOfInterests', JSON.stringify(aoi));
    },
    setEmailPreferences(state, ep) {
      state.emailPreferencesList = ep;
      window.sessionStorage.setItem('emailPreferences', JSON.stringify(ep));
    },
    setMyMemberDetails(state, mmd) {
      state.myMemberDetails = mmd;
    },
    setEoiForm(state, ef) {
      state.eoiForm = ef;
      window.sessionStorage.setItem('eoiForm', JSON.stringify(ef));
    },
    setCountryList(state, cl) {
      state.countryList = cl;
      window.sessionStorage.setItem('countryList', JSON.stringify(cl));
    },
    setDxExchangeTypeList(state, dx) {
      state.dxExchangeTypeList = dx;
      window.sessionStorage.setItem('dxExchangeTypeList', JSON.stringify(dx));
    },
  },
  actions: { // store.dispatch
    setUserAccount({ commit }, authorizedUser: AuthorizedUser) {
      commit('setAuthorizedUser', authorizedUser);
    },
    setSnackbar({ commit }, sb) {
      // console.log('setSnackbar:', sb);
      commit('setSnackbar', sb);
    },
    setMyCommittees({ commit }, mc) {
      // console.log('setMyCommittees:', mc);
      commit('setMyCommittees', mc)
    },
    setAreaOfInterests({ commit }, aoi) {
      commit('setAreaOfInterests', aoi)
    },
    setEmailPreferences({ commit }, ep) {
      commit('setEmailPreferences', ep)
    },
    setMyMemberDetails({ commit }, mmd) {
      // console.log('setMyMemberDetails: ', mmd);
      commit('setMyMemberDetails', mmd)
    },
    setEoiForm({ commit }, ef) {
      // console.log('setEoiForm: ', ef);
      commit('setEoiForm', ef);
    },
    setCountryList({ commit }, cl) {
      // console.log('setCountryList: ', cl)
      commit('setCountryList', JSON.stringify(cl));
    },
    setDxExchangeTypeList({ commit }, dx) {
      // console.log('setCountryList: ', cl)
      commit('setDxExchangeTypeList', JSON.stringify(dx));
    }
  },
  modules: {
  },
  getters: {
    getUserAccount: (state) => state.authorizedUser,
    getEventController: (state) => state.eventController,
    getSnackbar: (state) => state.snackbar,
    getMyCommittees: (state) => state.myCommittees,
    getAreaOfInterests: (state) => state.areaOfInterestsList,
    getEmailPreferences: (state) => state.emailPreferencesList,
    getMyMemberDetails: (state) => state.myMemberDetails,
    getEoiForm: (state) => state.eoiForm,
    getCountryList: (state) => state.countryList,
    getDxExchangeTypeList: (state)=>state.dxExchangeTypeList
  }
})
